import React, { useState } from 'react';
import ticketService from '../../services/ticketService';
import RecordUpdateFields from './RecordUpdateFields';
import TicketFieldList from './TicketFieldList';

const textValue = value => value == null ? '—' : typeof value === 'object' ? JSON.stringify(value) : String(value);
const RecordUpdatePanel = ({ ticket, onUpdate, onEditingChange }) => {
  const [draft, setDraft] = useState(null);
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const request = ticket.record_update;
  const edit = value => { setDraft(value); onEditingChange?.(!!value); setError(''); };
  const submit = async decision => {
    setSaving(true);
    setError('');
    const result = decision
      ? await ticketService.decideRecordUpdate(ticket._id, { decision, note, expected_revision: ticket.request_revision || 0 })
      : await ticketService.updateTicketRequest(ticket._id, { record_update: { data: draft.data }, expected_revision: ticket.request_revision || 0 });
    setSaving(false);
    if (result.success) { onUpdate(result.data); edit(null); }
    else setError(result.message || 'Unable to save record change.');
  };
  return <div className="card ticket-content-card">
    <div className="ticket-section-heading"><h3>Update {request.label} · {request.record_label}</h3>
      {request.status === 'pending' && ticket.workflow.can_edit_details && !draft && <button type="button" className="btn btn-secondary" onClick={() => edit({ ...request, data: { ...request.data } })}>Edit proposed changes</button>}
    </div>
    <p className="ticket-muted">Finance or Superadmin approval applies these changes to the existing record.</p>
    {draft ? <>
      <RecordUpdateFields value={draft} onChange={setDraft} disabled={saving} lockRecord />
      <div className="ticket-approval-actions"><button type="button" className="btn btn-secondary" disabled={saving} onClick={() => edit(null)}>Cancel</button>
        <button type="button" className="btn btn-primary" disabled={saving} onClick={() => submit()}>Save proposed changes</button></div>
    </> : <TicketFieldList fields={(request.display_data || []).map(field => ({ label: field.label,
      value: `${Object.hasOwn(request.before_data || {}, field.key) ? textValue(request.before_data[field.key]) : 'Restricted'} → ${textValue(field.value)}` }))} />}
    {!draft && ticket.workflow.can_decide_record_update && <>
      <label>Decision note<textarea className="input" value={note} onChange={event => setNote(event.target.value)} disabled={saving} /></label>
      <div className="ticket-approval-actions">
        {request.status === 'pending' && <button type="button" className="btn btn-secondary" disabled={saving} onClick={() => submit('reject')}>Reject</button>}
        <button type="button" className="btn btn-primary" disabled={saving} onClick={() => submit('approve')}>{saving ? 'Saving…' : request.status === 'approved' ? 'Apply approved change' : 'Approve and apply'}</button>
      </div>
    </>}
    {error && <p role="alert" className="ticket-inline-notice is-error">{error}</p>}
  </div>;
};
export default RecordUpdatePanel;
